import { createBrowserRouter, Navigate } from "react-router-dom";
import { LoginPage, MainPage } from "../pages";
import { PrivateRoute, RoleGuard, StatisticsAutoLoginGate } from "../components/private-route";
import { RegisterPage } from "../pages/register";
import { Route } from "./Route";
import { UploadPage } from "../pages/upload";
// import UsersPage from "../pages/users/UsersPage";
// import {DashboardPage} from "../pages/dashboard";
// import { FeatureTogglesPage } from "../pages/toggles";
// import {TokensPage} from "../pages/TokensPage";
// import {BusinessSettingsPage} from "../pages/business";
import { ClientsPage } from "../pages/clients";
import { StatisticsPage } from "../pages/statisticsPage";
import { getLandingRoute } from "../utils/auth";

const CatchAllRedirect = () => {
  const landing = getLandingRoute();
  return landing ? <Navigate to={`/${landing}`} replace /> : null;
};

const baseRoutes = [
  {
    path: `/${Route.Register}`,
    element: <RegisterPage />,
  },
  {
    path: `/${Route.Login}`,
    element: <LoginPage />,
  },
  {
    path: `/${Route.Statistics}`,
    element: (
      <StatisticsAutoLoginGate>
        <MainPage />
      </StatisticsAutoLoginGate>
    ),
    children: [{ index: true, element: <StatisticsPage /> }],
  },
  {
    path: "/",
    // @ts-ignore
    element: (
      <PrivateRoute key="main-page-route">
        <MainPage key="main-page" />
      </PrivateRoute>
    ),
    children: [
      { path: `/${Route.Upload}`, element: <RoleGuard page={Route.Upload}><UploadPage /></RoleGuard> },
      // { path: `/${Route.Dashboard}`, element: <VisitorGuard><DashboardPage /></VisitorGuard> },
      // { path: `/${Route.Users}`, element: <VisitorGuard><UsersPage /></VisitorGuard> },
      // { path: `/${Route.Tokens}`, element: <VisitorGuard><TokensPage /></VisitorGuard> },
      // { path: `/${Route.FeatureToggles}`, element: <VisitorGuard><FeatureTogglesPage /></VisitorGuard> },
      // { path: `/${Route.BusinessSettings}`, element: <VisitorGuard><BusinessSettingsPage /></VisitorGuard> },
      { path: `/${Route.Clients}`, element: <RoleGuard page={Route.Clients}><ClientsPage /></RoleGuard> },
      { path: "/", element: <CatchAllRedirect /> },
      { path: "*", element: <CatchAllRedirect /> },
    ],
  },
];

export const appRouter = createBrowserRouter(baseRoutes);
export const appRouterBusiness = createBrowserRouter(baseRoutes);
